import React from "react";
import { bool, func, object, oneOf } from "prop-types";
import Text from "../../shared/text/text";
import { list } from "react-immutable-proptypes";
import { MultiSelect, MultiSelectCreatable } from "../../shared/select";

const portalTargetElement = document.createElement("div");
portalTargetElement.style = "pointer-events: auto;"; // So it can be used inside of modals
document.body.appendChild(portalTargetElement);

const TagsSelect = ({
  autoExpand,
  onChange,
  options,
  value,
  readOnly,
  menuPortalTarget,
  menuPlacement,
  isCreatable,
  placeholderTid = "tags.select.placeholder",
}) => {
  function noOptionsMessage() {
    return <Text tid="no_custom_tags_found" />;
  }

  function formatCreateLabel(val) {
    return (
      <span>
        <Text tid="documents.create_new_tag" />: {val}
      </span>
    );
  }

  const commonProps = {
    autoExpand,
    options,
    optionsValue: "id",
    optionsLabel: "name",
    filterType: "word-match",
    placeholderTid,
    onChange,
    hideDropdownIndicator: true,
    noOptionsMessage,
    openMenuOnClick: true,
    value,
    isDisabled: readOnly,
    menuPortalTarget,
    menuPlacement,
  };

  if (isCreatable) {
    return (
      <MultiSelectCreatable
        {...commonProps}
        formatCreateLabel={formatCreateLabel}
      />
    );
  }

  return <MultiSelect {...commonProps} />;
};

TagsSelect.defaultProps = {
  readOnly: false,
  menuPortalTarget: portalTargetElement,
  menuPlacement: "auto",
  isCreatable: true,
  autoExpand: true,
};

TagsSelect.propTypes = {
  options: list,
  onChange: func,
  readOnly: bool,
  menuPortalTarget: object,
  menuPlacement: oneOf(["top", "bottom", "auto"]),
  isCreatable: bool,
  autoExpand: bool,
};

export default TagsSelect;
